module.exports = {
    // basic
    'range': 'rango',
    'months-previous': 'meses previos',
    'include-tbd': 'Incluir por determinar',
    // raw
    'select-at-least-one-entry-type': 'Se debe seleccionar al menos un tipo de entrada.',
    'must-select-spud-date': 'Debes seleccionar fecha de perforación.',
    'must-select-spud-date-range': 'Debes seleccionar comienzo y fin.',
    'must-enter-months-previous': 'Debes escribir meses previos.',
    'must-select-spud-date-or-upload-date': 'You must select spud date filter or upload date filter.',
	// template
};
